<template>
  <v-layout class="row wrap mt-2">
    <v-flex class="xs12">
      <v-layout row wrap>
        <v-flex sm12>
          <v-img
            :src="post.main_image"
            id="main_image"
            height="200"
            min-width="250"
          >
          </v-img>
        </v-flex>
        <v-flex sm12>
          <v-card flat>
            <v-flex pa-4 style="background-color: #f4f4f2">
              <PostContent 
                :title="post.title"
                :content="post.content" 
                :published_date="post.published_at" 
                :post_type="post.post_type"
              />
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex sm12>
          <gallery :postId="post.id" :key="post.id" />
        </v-flex>
        
        <v-flex sm12 class="mt-2">
          <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
          <v-card>
            <PostLikes :post="post" v-if="(post.interactions && post.interactions.length) || post.accept_interactions" />
            <CommentList 
              v-if="comments.length || post.accept_comments"
              :comments="comments" 
              :postSlug="post.slug"
              :page="page"
              @set-page="(value) => { page = value}"
            />
            <v-flex sm12 mt-3 ml-3 v-if="post.accept_comments">
              <TextareaEmojiPicker 
                :postSlug="post.slug"
                :page="page"
                @set-page="(value) => { page = value}"
              />
            </v-flex>
          </v-card>
        </v-flex>

      </v-layout>
    </v-flex>

    <v-flex sm12 v-if="true">
      <!-- <post-related :relatedPosts="post.relationed_posts" /> -->
      <v-flex class="text-15-security blue-security font-weight-bold py-2 pl-2">Noticias relacionadas</v-flex>

      <v-layout row wrap>
        <v-flex
          xs6 md6
          v-for="post in post.relationed_posts" 
          :key="post.id" 
          @click="goToShowPost(post)" 
          pb-2
        >      
          <PostCardMobile :post="post" marginX="mx-1" />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-layout justify-center>
      <v-flex>
        <v-btn flat @click="goToPostsList">Volver a noticias</v-btn>
        <v-btn 
          v-if="current_user.role.includes('admin')" 
          color="warning" 
          :href="post.url" 
          target="_blank"
        >
          Editar
        </v-btn>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import axios from "axios";
import Gallery from "@/components/General/Gallery";
import PostMainImage from "./PostMainImage";
import PostContent from "./PostContent";
import PostRelated from "./PostRelated";
import PostCardMobile from "./PostCardMobile";
import TextareaEmojiPicker from "./TextareaEmojiPicker"
import CommentList from "./CommentList"
import PostLikes from "./PostLikes"


let style = ["transparent", "red lighten-2", "orange lighten-3"];
export default {
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      page: 1
    }
  },
  components: {
    Gallery, PostMainImage, PostContent, PostRelated, PostCardMobile, TextareaEmojiPicker, CommentList, PostLikes
  },
  computed: {
    ...mapState("user", ["current_user"]),
    ...mapState("comments", ["comments", "loading"]),
  },
  methods: {
    ...mapMutations("posts", ["setPost"]),
    ...mapActions("comments", ["fetchComments"]),
    goToPostsList() {
      this.$router.push({
        name: "posts"
      });
    },
    async goToShowPost(post) {
      this.$router.push({
        name: "post-show",
        params: { slug: post.slug }
      });
      const res = await axios.get(process.env.VUE_APP_API_URL + `/posts/${post.slug}`)
      this.setPost(res.data);
    },
    getStyle(idx) {
      return style[idx];
    },
    image_link() {
      var image = document.getElementById("main_image").children[1].style
        .backgroundImage;
      var link_download = image.match(/\((.*?)\)/)[1].replace(/('|")/g, "");
      window.open(link_download, "_blank");
    }
  },
  created() {
    this.fetchComments({ slug: this.$route.params.slug, page: 1 })
  },
};
</script>

<style>

@media screen and (min-width: 1367px) {
  .pswp__caption {
    bottom: 0px !important;
  }
}

.pswp__caption__center {
    text-align: center;
}

.download_image {
  font-weight: 700;
}
.gallery_title {
  padding-right: 130px;
}

.icon-hover {
  color: white;
  font-size: 30px;
}
.icon-hover:hover {
  color: #638d37;
}

.lb-more:before {
  display: inline-block;
  content: "";
  vertical-align: middle;
  height: 100%;
}
.lb-more {
  position: absolute !important;
  top: 165px !important;
  left: 555px !important;
  right: 40px !important;
  bottom: 5px !important;
  text-align: center !important;
  color: #fff !important;
  font-size: 3rem !important;
  background-color: rgba(0,0,0,0.4) !important;
  z-index: 99;
}

.lb-more-mobile {
  position: absolute !important;
  top: 520px !important;
  left: 184px !important;
  right: 40px !important;
  bottom: 5px !important;
  text-align: center !important;
  color: #fff !important;
  font-size: 3rem !important;
  background-color: rgba(0,0,0,0.4) !important;
  z-index: 99;
  padding: 6rem 5.3rem;
}
</style>


